import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getTransactionListV1, getTotalTransactions } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../src/assets/bewiseloading.gif';

class paymentTransactions extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              paymentList: [],
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
        };

        
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

      this.getTotal('transactions');
      this.getList();
    }

    getTotal = (vertical, location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalTransactions(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    } 

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }       
 


    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getTransactionListV1(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            paymentList: res.list
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            paymentList: [],
          });
        }
      });


    }     

    render() {

        const { paymentList } = this.state;

        const { currentPage, PER_PAGE, totalCount, total } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Payment Transactions</h4>
                 
                  <div class="table-responsive pt-3">
                    <table  id="tablebw">
                      <thead>
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Date</strong>
                          </th>
                          
                          <th>
                            <strong>Payment ID</strong>
                          </th>
                          <th>
                            <strong>Partner name</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>

                          <th>
                            <strong>Package Chosen</strong>
                          </th>
                           <th>
                            <strong>Amount</strong>
                          </th>

                          <th>
                            <strong>Status</strong>
                          </th>
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {paymentList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {item.s_no}
                          </td>
                          <td>
                           {item.transaction_date}
                          </td>
                          
                          <td>
                           {item.razorpay_payment_id}
                          </td>
                          <td>
                            {item.name}
                          </td>
                          <td>
                            {item.user_type}
                          </td>
                          <td>
                            {item.plan_id}
                          </td>
                          <td>
                            {item.amount}
                          </td>

                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                     
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default paymentTransactions;


// WEBPACK FOOTER //
// ./src/components/bewise/transactions.jsx